module.exports = __webpack_public_path__ + "static/img/fish5.e62e96a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fish/flydragonfish/fish5.png
// module id = X6St
// module chunks = 0